import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { array } from 'fp-ts';
import { AmountPart, RelativeProductPrice } from '@mews-commander/data-access';
import { DividerList, LabeledListItem, SpacedComma } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedPercentage, lt } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { useProductNames } from '../../../queries/useProductNames';

interface Props {
    pricing: RelativeProductPrice;
}
export const RelativePricingSection = ({ pricing }: Props) => (
    <DividerList>
        <LabeledListItem label={lt('PricingType')}>
            <Tag variant="basicSubtle" outline>
                {lt('Relative')}
            </Tag>
        </LabeledListItem>
        <LabeledListItem label={lt('Value')}>
            {pricing.target ? lt(`ProductPricingTarget${pricing.target as AmountPart}`) : UnicodeEntity.Dash}
        </LabeledListItem>
        <LabeledListItem label={lt('GeneralPercentage')}>
            {pricing.multiplier ? (
                <LocalizedPercentage value={pricing.multiplier} options={{ maximumFractionDigits: 2 }} />
            ) : (
                UnicodeEntity.Dash
            )}
        </LabeledListItem>
        {pricing.productIds && array.isNonEmpty(pricing.productIds) ? (
            <RelativeProductNames productIds={pricing.productIds} />
        ) : null}
    </DividerList>
);

const RelativeProductNames = ({ productIds }: { productIds: NonEmptyArray<string> }) => {
    const productNames = useProductNames(productIds);
    return (
        <LabeledListItem label={lt('ProductPlural')}>
            {productNames ? productNames.join(SpacedComma) : UnicodeEntity.Dash}
        </LabeledListItem>
    );
};
